// Username thật của shop khi store chạy trên tên miền riêng (không suy ra được từ hostname).
// Lấy từ API shop/store (đã qua kiểm tra verify domain), chỉ giữ trong bộ nhớ của phiên hiện tại.
// Không lưu localStorage: nếu không, request đầu tiên sẽ gửi kèm username cũ và bỏ qua kiểm tra verify.
let shopUsername = '';

export const setShopUsername = (username?: string) => {
    shopUsername = username || '';
};

export const getShopUsername = (): string => shopUsername;
